import panelBronzeLandscape from '@assets/jackpot-eq/panel-bronze-l.png'
import panelBronzePortrait from '@assets/jackpot-eq/panel-bronze-p.png'
import panelSilverLandscape from '@assets/jackpot-eq/panel-silver-l.png'
import panelSilverPortrait from '@assets/jackpot-eq/panel-silver-p.png'
import panelGoldLandscape from '@assets/jackpot-eq/panel-gold-l.png'
import panelGoldPortrait from '@assets/jackpot-eq/panel-gold-p.png'
import panelPlatinumLandscape from '@assets/jackpot-eq/panel-platinum-l.png'
import panelPlatinumPortrait from '@assets/jackpot-eq/panel-platinum-p.png'
import usernamePanelBronze from '@assets/jackpot-eq/username-panel-bronze.png'
import usernamePanelSilver from '@assets/jackpot-eq/username-panel-silver.png'
import usernamePanelGold from '@assets/jackpot-eq/username-panel-gold.png'
import usernamePanelPlatinum from '@assets/jackpot-eq/username-panel-platinum.png'

import { JackpotEQConfigType } from './types'
import { JackpotEQLevels, ViewportType } from 'game-ui-types'

export const JackpotEQColors = {
    [JackpotEQLevels.BRONZE]: '#dc9b42',
    [JackpotEQLevels.SILVER]: '#ffffff',
    [JackpotEQLevels.GOLD]: '#ffda55',
    [JackpotEQLevels.PLATINUM]: '#ffffff',
}

const jackpotEQConfigFactory = (type: JackpotEQLevels = JackpotEQLevels.BRONZE): JackpotEQConfigType => ({
    [ViewportType.MOBILE_PORTRAIT]: {
        jackpotStatistics: {
            topRowMargin: { bottom: 26 },
            panelOuter: {
                width: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 330 : 242,
                height: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 72 : 62,
                marginBetween: 0,
            },
            amountBox: {
                width: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 288 : 182,
                height: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 44 : 38,
                fontSize: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 48 : 38,
                leftSymbolPadding: -10,
                top: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 8 : 7,
            },
            odometer: {
                winActiveTop: 5,
                fontSize: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 50 : 42,
                fontColor: '#ffffff',
                lineHeight: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 47 : 40,
                fontWeight: '900',
                digitWidthPadding: 3,
                spaces: {
                    width: 8,
                },
            },
            winningUser: {
                top: 6,
                fontWeight: '700',
                fontSize: 16,
                lineHeight: 18,
                fontColor: JackpotEQColors[type],
            },
            currency: {
                paddingBottom: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 11 : 10,
                right: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 13 : 10,
                fontWeight: '700',
                fontSize: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 15.1 : 13,
                fontColor: '#DFDFDF',
                lineHeight: type === JackpotEQLevels.PLATINUM || type === JackpotEQLevels.GOLD ? 13.94 : 12,
                width: 12,
            },
        },
        images: {
            panel: {
                [JackpotEQLevels.BRONZE]: panelBronzePortrait,
                [JackpotEQLevels.SILVER]: panelSilverPortrait,
                [JackpotEQLevels.GOLD]: panelGoldPortrait,
                [JackpotEQLevels.PLATINUM]: panelPlatinumPortrait,
            }[type],
            usernamePanel: {
                [JackpotEQLevels.BRONZE]: usernamePanelBronze,
                [JackpotEQLevels.SILVER]: usernamePanelSilver,
                [JackpotEQLevels.GOLD]: usernamePanelGold,
                [JackpotEQLevels.PLATINUM]: usernamePanelPlatinum,
            }[type],
        },
        extended: {},
    },
    [ViewportType.MOBILE_LANDSCAPE]: {
        jackpotStatistics: {
            panelOuter: {
                width: 261,
                height: 62,
                marginBetween: type === JackpotEQLevels.SILVER || type === JackpotEQLevels.GOLD ? 10 : 0,
            },
            amountBox: {
                width: 224,
                height: 38,
                fontSize: 38,
                leftSymbolPadding: -7,
                top: 7,
            },
            odometer: {
                winActiveTop: 2,
                fontSize: 38,
                fontColor: '#ffffff',
                lineHeight: 40,
                fontWeight: '900',
                digitWidthPadding: 3,
                spaces: {
                    width: 8,
                },
            },
            winningUser: {
                top: 6,
                fontWeight: '700',
                fontSize: 16,
                lineHeight: 18,
                fontColor: JackpotEQColors[type],
            },
            currency: {
                paddingBottom: 9,
                right: 11,
                fontWeight: '700',
                fontSize: 13,
                lineHeight: 12,
                fontColor: '#DFDFDF',
                width: 12,
            },
        },
        images: {
            panel: {
                [JackpotEQLevels.BRONZE]: panelBronzeLandscape,
                [JackpotEQLevels.SILVER]: panelSilverLandscape,
                [JackpotEQLevels.GOLD]: panelGoldLandscape,
                [JackpotEQLevels.PLATINUM]: panelPlatinumLandscape,
            }[type],
            usernamePanel: {
                [JackpotEQLevels.BRONZE]: usernamePanelBronze,
                [JackpotEQLevels.SILVER]: usernamePanelSilver,
                [JackpotEQLevels.GOLD]: usernamePanelGold,
                [JackpotEQLevels.PLATINUM]: usernamePanelPlatinum,
            }[type],
        },
        extended: {},
    },
    [ViewportType.DESKTOP]: {
        jackpotStatistics: {
            panelOuter: {
                width: 348,
                height: 83,
                marginBetween: type === JackpotEQLevels.SILVER || type === JackpotEQLevels.GOLD ? 12 : 0,
            },
            amountBox: {
                width: 300,
                height: 51,
                fontSize: 51,
                leftSymbolPadding: -10,
                top: 8,
            },
            odometer: {
                winActiveTop: 4,
                fontSize: 51,
                fontColor: '#ffffff',
                lineHeight: 55,
                fontWeight: '900',
                digitWidthPadding: 3,
                spaces: {
                    width: 8,
                },
            },
            winningUser: {
                top: 4,
                fontWeight: '700',
                fontSize: 16,
                lineHeight: 21,
                fontColor: JackpotEQColors[type],
            },
            currency: {
                paddingBottom: 14,
                right: 14,
                fontWeight: '700',
                fontSize: 17.4,
                lineHeight: 16,
                fontColor: '#DFDFDF',
                width: 17,
            },
        },
        images: {
            panel: {
                [JackpotEQLevels.BRONZE]: panelBronzeLandscape,
                [JackpotEQLevels.SILVER]: panelSilverLandscape,
                [JackpotEQLevels.GOLD]: panelGoldLandscape,
                [JackpotEQLevels.PLATINUM]: panelPlatinumLandscape,
            }[type],
            usernamePanel: {
                [JackpotEQLevels.BRONZE]: usernamePanelBronze,
                [JackpotEQLevels.SILVER]: usernamePanelSilver,
                [JackpotEQLevels.GOLD]: usernamePanelGold,
                [JackpotEQLevels.PLATINUM]: usernamePanelPlatinum,
            }[type],
        },
        extended: {},
    },
})

export const jackpotEQConfig = {
    [JackpotEQLevels.BRONZE]: jackpotEQConfigFactory(JackpotEQLevels.BRONZE),
    [JackpotEQLevels.SILVER]: jackpotEQConfigFactory(JackpotEQLevels.SILVER),
    [JackpotEQLevels.GOLD]: jackpotEQConfigFactory(JackpotEQLevels.GOLD),
    [JackpotEQLevels.PLATINUM]: jackpotEQConfigFactory(JackpotEQLevels.PLATINUM),
}

export const defaultJackpotEQConfig = jackpotEQConfig[JackpotEQLevels.BRONZE]
